/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Page_SubtitleInputs */



/**
* | output |
* | --- |
* | "Configure pattern templates and the compliance copilot to stay ahead of sensitive requests." |
*
* @param {Compliance_Page_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_page_subtitle = /** @type {((inputs?: Compliance_Page_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Page_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konfigurieren Sie Mustervorlagen und den Compliance-Copiloten, um sensiblen Anfragen immer einen Schritt voraus zu sein.")
	return /** @type {LocalizedString} */ ("Configure pattern templates and the compliance copilot to stay ahead of sensitive requests.")
});